import { CatalogicalGeneratedModel, ItemModel } from "lib/services/catalogical-models";

export enum Visibility {
  PRIVATE = "private",
  PUBLIC = "public",
  SHARED = "shared",
}

export interface ListItem extends ItemModel {
  addedAt: Date;
  addedBy: string;
  status: string;
}

export interface ListModel {
  listId: string;
  name: string;
  description?: string;
  ownerAlias: string;
  items: ListItem[];
  itemCount: number;
  visibility: Visibility;
  fullItems: ItemModel[];
  allowedDomains: string[];
  tags: string[];
  /**
   * Autogenerated attributes by Catalogical
   */
  catalogicalGenerated?: CatalogicalGeneratedModel;
}

// Request/Response interfaces for Lists API
export interface GetListsResponse {
  lists: ListModel[];
  totalCount: number;
}

export interface GetListResponse {
  list: ListModel;
}

export interface CreateListRequest {
  name: string;
  description?: string;
  visibility?: string;
  allowedDomains?: string[];
  tags?: string[];
  itemIds?: string[];
}

export interface UpdateListRequest {
  name?: string;
  description?: string;
  visibility?: string;
  allowedDomains?: string[];
  tags?: string[];
}

export interface AddItemToListRequest {
  itemIds: string[];
  listId?: string;
  autoCreate?: boolean;
  name?: string;
  domain?: string;
}

export interface EvaluateListsRequest {
  taxonomyIds: string[];
}

export interface EvaluateListsResponse {
  evaluations: {
    taxonomyId: string;
    lists: string[];
  }[];
}
